module.exports = __webpack_public_path__ + "img/img_chaxun.f1c8cc13.jpg";